import { stripIndent } from 'common-tags';
import { SubscriptionPastDue } from './components/SubscriptionPastDue';

export const subscriptionPastDueEmailTemplate = {
  label: 'Subscription Past Due',
  description: 'Sent when a subscription payment fails and the subscription is at risk',
  icon: 'ErrorWarningLine',
  component: SubscriptionPastDue,
  defaultTemplate: {
    name: 'Subscription Past Due',
    subject: {
      en: 'Action required: payment failed for {{ subscriptionName }} — {{ storeName }}',
      fr: 'Action requise : échec du paiement pour {{ subscriptionName }} — {{ storeName }}',
      it: 'Azione richiesta: pagamento fallito per {{ subscriptionName }} — {{ storeName }}',
      es: 'Acción requerida: pago fallido para {{ subscriptionName }} — {{ storeName }}',
      de: 'Handlung erforderlich: Zahlung fehlgeschlagen für {{ subscriptionName }} — {{ storeName }}',
    },
    templateVariables: {
      subscription_past_due: {
        body: {
          en: stripIndent`
            <p>Hi {{ customerFirstName }},</p>
            <p>We were unable to process your payment of <strong>{{ subscriptionAmount }}</strong> for your subscription to <strong>{{ subscriptionName }}</strong>.</p>
            <p>Please update your payment method to avoid losing access to your subscription.</p>
            <p>If you believe this is an error, please contact your bank or reach out to us for assistance.</p>
          `,
          fr: stripIndent`
            <p>Bonjour {{ customerFirstName }},</p>
            <p>Nous n'avons pas pu traiter votre paiement de <strong>{{ subscriptionAmount }}</strong> pour votre abonnement à <strong>{{ subscriptionName }}</strong>.</p>
            <p>Veuillez mettre à jour votre moyen de paiement pour éviter de perdre l'accès à votre abonnement.</p>
            <p>Si vous pensez qu'il s'agit d'une erreur, contactez votre banque ou contactez-nous pour obtenir de l'aide.</p>
          `,
          it: stripIndent`
            <p>Ciao {{ customerFirstName }},</p>
            <p>Non siamo riusciti a elaborare il tuo pagamento di <strong>{{ subscriptionAmount }}</strong> per il tuo abbonamento a <strong>{{ subscriptionName }}</strong>.</p>
            <p>Aggiorna il tuo metodo di pagamento per evitare di perdere l'accesso al tuo abbonamento.</p>
            <p>Se ritieni che si tratti di un errore, contatta la tua banca o contattaci per assistenza.</p>
          `,
          es: stripIndent`
            <p>Hola {{ customerFirstName }},</p>
            <p>No pudimos procesar tu pago de <strong>{{ subscriptionAmount }}</strong> para tu suscripción a <strong>{{ subscriptionName }}</strong>.</p>
            <p>Por favor, actualiza tu método de pago para evitar perder el acceso a tu suscripción.</p>
            <p>Si crees que se trata de un error, contacta a tu banco o comunícate con nosotros para obtener ayuda.</p>
          `,
          de: stripIndent`
            <p>Hallo {{ customerFirstName }},</p>
            <p>Wir konnten deine Zahlung von <strong>{{ subscriptionAmount }}</strong> für dein Abonnement <strong>{{ subscriptionName }}</strong> nicht verarbeiten.</p>
            <p>Bitte aktualisiere deine Zahlungsmethode, um den Zugang zu deinem Abonnement nicht zu verlieren.</p>
            <p>Falls du glaubst, dass es sich um einen Fehler handelt, kontaktiere bitte deine Bank oder wende dich an uns.</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'subscriptionName', label: 'Subscription Name', example: 'VIP Club' },
    { key: 'subscriptionAmount', label: 'Subscription Amount', example: '$19.99' },
    { key: 'cardUpdateLink', label: 'Update Card Link', example: 'https://...' },
  ],
  utmParameters: {
    utmSource: 'subscription_past_due',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
      currency: 'USD',
    },
    subscription: {
      currency: 'USD',
      product: { name: 'VIP Club' },
      priceSnapshot: { currencyOptions: { USD: { amount: 1999 } } },
    },
  }),
  defaultMessages: {
    promotion_title: 'Payment Failed',
    promotion_subtitle: 'Please update your payment method',
    cta_button: 'Update Payment',
    footer_text: '© 2025 All rights reserved',
  },
};
